import {useEffect, useState, useCallback} from "react";
import {Link, useNavigate, useLocation} from "@tanstack/react-router"
import Web3 from "web3";
import {_AuctionManager, _SGBF_ERC721} from "../../../../abi";
import {chainData} from "../../../../chains"
import {Modal2} from "../../../../components/Modal"
//import BreadcrumbSimple from "../../../../components/BreadcrumbSimple";
//import ReactJson from 'react-json-view'
import {logger} from "../../../../utils";
import AddressToAccount from "../../../../components/AddressToAccount";
//import {BN} from "web3-utils";
import {toast} from "react-toastify";
import {BigNumber} from "bignumber.js";
import { useAppKit, useAppKitProvider } from '@reown/appkit/react'
import {ethers} from 'ethers'
import {
    FacebookShareButton,
    TelegramShareButton,
    TwitterShareButton,
    FacebookIcon,
    TelegramIcon,
    TwitterIcon
} from "react-share";
import Vcl from "../../../../components/ViewsCommentsLikes/index.jsx";
import { getVolumeInfo, removeListing } from '../../../../lib/api';
import { sessionStorageGet, sessionStorageSet } from '../../../../lib/window-shim';
import { PriceConverterABI } from "../../../../abi/PriceConverter.js";
import { useAppKitAccount, useAppKitNetwork } from "@reown/appkit/react";
import React from "react";


/**
 * SectionInfo component.
 *
 * Displays detailed information about an NFT item including:
 * - Collection link and item identifier
 * - Volume statistics with time period selection
 * - Current price/bid information
 * - Action buttons (Show Meta, Sell, Transfer, Buy It Now, Manage)
 * - Social sharing (Twitter, Facebook, Telegram)
 * - Owner and collection owner addresses
 *
 * Manages modal for metadata viewing and listing management.
 * Handles various owner and non-owner actions based on authentication.
 *
 * @param {Object} props - Component props
 * @param {Object} props.shit - Collection data
 * @param {string|number} props.itemId - Token ID
 * @param {Object} props.ti - Token/item information including owner, auctionData, metadata
 * @param {Function} props.rr - Refetch callback to refresh data
 * @returns {React.ReactElement} Item info section with action buttons
 */
const SectionInfo = ({shit, itemId, ti, rr}) => {

    // eslint-disable-next-line no-unused-vars
    const {wallet, open, close} = useAppKit()
    const { walletProvider } = useAppKitProvider("eip155");

    const { isConnected, address } = useAppKitAccount();
    const { chainId } = useAppKitNetwork();
    // let token = window.sessionStorage.getItem('token');
    // let _token = {}; let bmp = "00000000"
    // try {
    //     _token = JSON.parse(token);
    //     bmp = _token.account.bmp.toString(2);
    // } catch (err) {}

    // Expose ti to window for debugging (client-only)
    if (typeof window !== 'undefined') {
      window.ti = ti;
    }

    let net;

    const navigate = useNavigate();
    const location = useLocation();


    if (shit?.network) net = chainData[shit?.network]?.network+" "+chainData[shit?.network]?.chainName;

    const [show, showModal] = useState(false);
    const [mContent, setMC] = useState("No Content Yet!")
    // eslint-disable-next-line no-unused-vars
    const [refresh, doref] = useState(0)
    const [actionButtons, setActionButtons] = useState([]);
    const [modalTitle, smc] = useState("Modal");
    const [volData, svd] = useState(null);
    const [volPer, svp] = useState("month")
    const [usdPrice, sUsd] = useState("");

    const getEthersProvider = useCallback(() => {
        if (!walletProvider) return null;
        const actualProvider = walletProvider.provider ? walletProvider.provider : walletProvider;
        return new ethers.providers.Web3Provider(actualProvider);
    }, [walletProvider]);
    

    // TODO: after a transfer, update the token owner in the database.

   // logger(window.sessionStorage.getItem("currentWallet"), ti.tokenOwner)

    logger(shit?.network, net, "aSHIT");

    //let roProvider = new Web3.providers.HttpProvider(chainData[1].rpc)

    let sellerDesc = null;


    useEffect(() => {
        const getButtons = () => {
            const buttons = [];
            let transfer, sell, itemMeta;

            itemMeta = <button className="pixel-btn w-100 mb-1"
                        onClick={() => metaModal()}>Show-Meta</button>;

            buttons.push(itemMeta)


            if (isConnected && address != null && ti?.owner) {
                if (address.toString().toLowerCase() === ti.owner.toLowerCase()) {


                    if (ti.hasOwnProperty("auctionData")) {
                        // if(bmp[6] === "1") {
                        sell = <button className="iDetailActions btn m-1 pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                       onClick={() => manageListing(ti.owner)}>Manage...</button>

                        buttons.push(sell)

                        // sellerDesc = <div onClick={() => itemDescription()}><u>See seller's description</u></div>
                        //actionButtons.push(sellerDesc)
                    } else {

                        sell = <button className="iDetailActions btn m-1 pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                       onClick={() => sellItem()}>Sell This Item</button>
                        buttons.push(sell)
                    }
                    transfer = <button className="iDetailActions btn m-1 pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                       onClick={() => transItem()}>Transfer Item</button>
                    buttons.push(transfer)

                } else {
                    if (ti.hasOwnProperty("auctionData")) {
                        if (ti?.auctionData?.finalizeOnReserveMet === true) {                   // but it now only
                            if (address.toLowerCase() !== ti?.owner?.toLowerCase()) {
                                sell = <button className="iDetailActions btn m-1 pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                               onClick={() => bIN()}>BUY IT, NOW!</button>
                                buttons.push(sell)
                            } else {
                                sell = <button className="iDetailActions btn m-1 pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                               disabled
                                               >BUY IT, NOW!</button>
                                buttons.push(sell)
                            }
                            transfer = null;

                        }
                    }
                }
            }
            //wtf
            if(transfer===null){
                //    transfer=itemMeta;
                itemMeta=null;
            }
            setActionButtons(buttons);
        }
        getButtons();
    }, [ti, isConnected, address]);



    const finalizeAuction = async (ownerAddr) => {

        const options = {value: "0", gasLimit: "8000000"}
        if(isConnected) {
            const provider = getEthersProvider();
            if (!provider) {
                toast.error("Wallet provider not available.");
                return;
            }
            if(address.toLowerCase()===ownerAddr.toLowerCase()){
                toast.error("Please connect with the wallet that owns the token ("+ownerAddr+")")

            } else {
                let amc = new ethers.Contract(chainData[shit.network].aManager, _AuctionManager, provider.getSigner())
                try {
                    await amc.deployed()
                    await amc.finalizeAuction(ti.bcd.contract, ti.bcd.tid, options)
                        .then(async r=> {
                            await r.wait()
                            await removeListing(ti)
                            toast.info(<>Item finalized</>)
                            showModal(false)
                            rr(Math.random())
                        })

                } catch (e) {
                    toast.error(<>
                        <span className="text-bolder">Sorry, I can't do that!</span>
                        <br/><br/>
                        <span style={{wordBreak: "break-all"}}>{e.message.substr(0,1500)}</span></>)

                }
            }
        } else {
            toast.error("Connect wallet first!")
        }
    }

    const finalizeEarly = async () => {
        let isOk = window.confirm("Please Note:\n\nFinalizing early will incur a 5% fee which is deducted from the current high bid.");
        if(isOk) {
            const options = {value: "0", gasLimit: "8000000"}
            const provider = getEthersProvider();
            if (!provider) return;
            let amc = new ethers.Contract(chainData[shit.network].aManager, _AuctionManager, provider.getSigner());
            let response = await amc.finalizeEarly(ti.bcd.contract, ti.bcd.tid, options);
            toast.success("Listing finalized early. "+JSON.stringify(response));
            toast.success("Auction has been finalized");
        } else {
            toast.info("Early finalization cancelled");
        }
    }

    const PullAuction = async () => {
        let isOk = window.confirm("Please Note:\n\nPulling an auction which currently has bidders will incur a penalty of 25% of the highest bidder's bid.\n\n"+
        "Your NFT will be returned to you, and the high bidders' bid will be refunded, plus 25% in compensation.");
        if(isOk) {
            const options = {value: "0", gasLimit: "8000000"}
            const provider = getEthersProvider();
            if (!provider) return;
            let amc = new ethers.Contract(chainData[shit.network].aManager, _AuctionManager, provider.getSigner())
            await amc.deployed()
            let response = await amc.removeListingBeforeEndTime(ti.bcd.contract, ti.bcd.tid, options);
            toast.success("Listing finalized early. "+JSON.stringify(response));
        } else {
            toast.warn("Early finalization cancelled");
        }
    }

    const manageListing = async (owner) => {
        smc("Manage Listing");
        setMC(<>

                    <br/>
                    <> { ti.hasOwnProperty("auctionData") ? <> {
                                            ti.auctionData.finalizeOnReserveMet === true ?
                                            <button style={{minWidth: "80%"}} className="pixel-btn fs-6 fw-bold w-100 mb-1 active"
                    onClick={() => finalizeAuction(owner)}>Remove Buy Now Listing
                    </button> : null } </> : null } </>
                    <> { ti.hasOwnProperty("auctionData") ? <> {
                        ti.auctionData.finalizeOnReserveMet === false ? <> {
                            ti.auctionData.finishTime < Math.floor(Date.now()/1000) ?
                                <><button className="pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                onClick={() => finalizeAuction(owner)}>Finalize Auction
                                </button><br/>FinTime: {ti.auctionData.finishTime} CurrTime: {Math.floor(Date.now()/1000)}</>
                            :
                                <><button className="pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                onClick={() => finalizeEarly()}>Finalize Auction Early
                                </button><br/>
                                <button className="pixel-btn fs-6 fw-bold w-100 mb-1 active"
                                        onClick={() => PullAuction()}>Remove Auction
                                </button>
                                </>
                            } </>
                        : null } </>
                    : null } </>

                    <br/>

                {/*</div>*/}
            <button className="pixel-btn fs-6 fw-bold w-100 mb-1 active"
                    onClick={() => showModal(false)}>Close
            </button>


        </>)
        showModal(true);

    }

    const notifyError = (error) => {
        toast(error, {autoClose: 30000});
    }

    const checkBin = async () => {
        const provider = getEthersProvider();
        if (!provider) {
            notifyError("Wallet not connected.");
            return;
        }

        let AMContractAddress = chainData[ti.chainDataID].aManager;
        const options = {value: "0", gasLimit: "8000000"}
        let tok = sessionStorageGet('token');
        let _tok = JSON.parse(tok)
        if(tok && _tok.auth===true) {
            if (chainId?.toString() === "0x" + parseInt(ti?.bcd?.chainInf?.chainId).toString(16)) {
                let web3 = new Web3(provider);
                let amc = new web3.eth.Contract(_AuctionManager, AMContractAddress);
                let auctionInfo = await amc.methods.getAuctionData(ti.bcd.contract, ti.bcd.tid).call()
                let minNextBid = new BigNumber(await amc.methods.minNextBidAmount(ti.bcd.contract, ti.bcd.tid).call());
                let bidPrice = minNextBid;

                if(address.toLowerCase()!== auctionInfo.ownerAddress.toLowerCase()) {
                    if (new BigNumber(bidPrice.toString()).gte(new BigNumber(minNextBid.toString()))) {
                        let bpbn =new BigNumber(bidPrice.toString());
                        let bpd = bpbn.div(new BigNumber(1000))
                            let cpd = bpd.mul(new BigNumber(25))
                        let fa=cpd.add(bpbn);
                        let amcEthers = new ethers.Contract(chainData[ti.chainDataID].aManager, _AuctionManager, provider.getSigner())
                        await amcEthers.deployed()
                        options.from = address;
                        options.value = fa.toString();
                        await amcEthers.submitNewBid(ti.bcd.contract, ti.bcd.tid.toString(), bpbn.toString(), options)
                            .then((_res) => {
                                notifyError("Sale completed! Congratulations! :)");
                                doref(Date.now())
                            })
                            .catch((_err) => {
                                notifyError(`Problem With Transaction :( ${JSON.stringify(_err)} 
                                    submitNewBid(${ti.bcd.contract}, ${ti.bcd.tid}, ${bidPrice} )`);
                                doref(Date.now())
                            })
                    } else {
                        notifyError("Bid rejected: Reserve not met. bp: " + bidPrice.toString() + " min: " + minNextBid.toString());
                    }
                } else {
                    notifyError("You can't buy your own items!!")
                }
            } else {
                notifyError("You're connected to the wrong chain. Please ensure you're using the " + ti?.bcd?.chainInf?.network + " " + ti?.bcd?.chainInf?.chainName + " blockchain (check your wallet and try to reconnect)")
            }
        } else {
            notifyError("It would probably help if you were signed in? :)");
        }
    }

    const bIN = async () => {
        await checkBin()
    }

    const sellItem = async () => {

        if(isConnected) {
            logger(chainId, ti?.bcd?.chainInf?.chainId);
            if (chainId?.toString(10) !== parseInt(ti?.bcd?.chainInf?.chainId).toString(10)) {
                let currentChainName = "Unknown blockchain (Chain ID: " + chainId + ")";
                for (const [key, value] of Object.entries(chainData)) {
                    logger(chainId, key, value);
                    if (value && chainId === parseInt(value.chainId).toString(16)) {
                        currentChainName = value.network + " " + value.chainName + "(Chain ID: " + value.chainId + ")";
                    }
                }
                toast.error("This item is on the " + ti?.bcd?.chainInf?.network + " " + ti?.bcd?.chainInf?.chainName + "(Chain ID: " + ti?.bcd?.chainInf?.chainId + ")" +
                    " blockchain.\n\nPlease check your wallet, and make sure you're connected to the correct blockchain.\n\nCurrent chain is: " +
                    currentChainName);
            } else {
                sessionStorageSet("sellItem", JSON.stringify({...shit, ...ti}))
                navigate({ to: "/list" });
            }
        } else {
            toast.error("Please connect your wallet first!")
        }
    }

    useEffect(() => {
        getVolData(ti);
        getUSDPrice();
    }, [mContent, ti]);

    const getVolData = async (ti) =>{
        svd(await getVolumeInfo(ti?.dbCdata?.contractAddress, ti?.bcd?.tid))
    }

    const metaModal = async () => {
        //	modalRef.current.props.show;
        let myJson = ti.meta;
        smc("Token Metadata")
        setMC(<>
                <div className="pixel-card" style={{
                    padding: "8px",
                    fontWeight: "bold",
                    overflowWrap: "anywhere",
                    overflowY: "scroll",
                    width: "auto",
                    height: "90%"
                }}>
                    {myJson?.attributes ? <>
                    {myJson.attributes.map((item) => <React.Fragment key={item.trait_type}>
                    <span style={{alignSelf: "flex-start"}} className="text-muted">{item.trait_type}</span>
                        <span style={{alignSelf: "flex-end"}} className="text-light">{item.value}</span>
                    </React.Fragment>
                    )
                    }</> : "This item has no traits defined!"}
                    <button style={{marginTop: "auto"}} className="pixel-btn w-100 mb-1"
                            onClick={() => showModal(false)}>Close
                    </button>
                </div>
        </>)
        showModal(true);
    }

    const transItem = async () => {
        const provider = getEthersProvider();
        if (!provider) {
            toast.error("Wallet not connected.");
            return;
        }
        const options = {value: "0", gasLimit: "8000000"}
        toast("hello"+"0x"+parseInt(chainId).toString(16));
   /*     if (chainId?.toString() !== "0x"+parseInt(ti.bcd.chainInf.chainId).toString(16)) {
            let currentChainName = "Unknown blockchain (Chain ID: " + chainId + ")";
            for (const [key, value] of Object.entries(chainData)) {
                if (value && chainId === "0x"+parseInt(value.chainId).toString(16)) {
                    currentChainName = value.network + " " + value.chainName + "(Chain ID: " + chainId + ")";
                }
            }
            toast.error(<>This item is on the {ti.bcd.chainInf.network } {ti.bcd.chainInf.chainName} ( Chain ID: {ti.bcd.chainInf.chainId} )
                blockchain.<br/><br/>Please check your wallet, and make sure you're connected to the correct blockchain.<br/><br/>
                Current chain is: {currentChainName}</>, {autoClose: 30000});
        } else {*/
            toast("trying...")
            let txTo = prompt("Enter the wallet address you wish to send this token to:")
            let erc721 = new ethers.Contract(ti.contractAddress, _SGBF_ERC721, provider.getSigner())
            let response = await erc721.transferFrom(address, txTo, itemId, options);
            toast(response.toString())
            logger(response)
            toast.success("You sent token ID " + itemId + " to " + txTo);
    //    }
    }
    //useEffect(()=>{}, [ti.meta.views])

    function onChangeValue(event) {
        document.getElementById("cb1").checked=false;
        document.getElementById("cb2").checked=false;
        document.getElementById("cb3").checked=false;
        document.getElementById(event?.target?.name).checked=true;
        svp(event?.target?.value)


    }

    const getUSDPrice = async () => {
        let calcAmount = "0";
        if(ti?.auctionData){
            if(ti?.auctionData?.finalizeOnReserveMet){
                calcAmount = ti?.auctionData?.reserveAmount;
            } else {
                calcAmount = ti?.auctionData?.bidAmount;
            }
            if(chainData[ti?.chainDataID]?.PriceConverter){
                let r = new ethers.providers.JsonRpcProvider(chainData[ti?.chainDataID].rpc);
                let c = new ethers.Contract(chainData[ti?.chainDataID]?.PriceConverter, PriceConverterABI, r);
                let USD = await c.PairToUSD(calcAmount, 11);
                sUsd("( $"+parseFloat(ethers.utils.formatEther(USD._priceInUSD.toString())).toFixed(2)+" )");
            }

        }
    }

    useEffect(()=>{}, [volPer])
    useEffect(()=>{}, [usdPrice])

    useEffect(()=>{
        document.getElementById("cb2").checked=true;
    }, [])

    return (
        <>
            <Modal2 show={show} modalTitle={modalTitle} content={mContent} handleClose={() => showModal(false)} />
            <div className="col-12">
            <div className="d-flex flex-column h-100">
                {(() => {
                  // Derive collection slug from the current URL path
                  const segments = location.pathname.split('/').filter(Boolean);
                  // Expected: /item/:chain/:contract/:tokenId
                  // contract is at index 2
                  const collectionSlug = segments.length >= 3 ? segments[2] : '';
                  return (
                    <h4 className="font-weight-bolder text-light">
                      <Link className="font-weight-bolder text-light" to={"/collections/"+collectionSlug}>{shit?.text1}</Link>
                    </h4>
                  );
                })()}
                <p className="mb-1 text-light">Item {itemId} of {shit?.amount} {ti?.meta?.__views? <>{"- "+ti.meta.__views+" view"}{ti.meta.__views>1? "s" : null}</> : "- 1 view" }</p>
                <div className={"text-light"} style={{overflow: "hide"}}>


                        <div className={"text-light"} onChange={(e)=>onChangeValue(e)}>
                            Volume: <input id="cb1" type="radio" value="week" name="cb1" /> Week&nbsp;
                            <input id="cb2" type="radio" value="month" name="cb2" /> Month&nbsp;
                            <input id="cb3" type="radio" value="all" name="cb3" /> All&nbsp; - &nbsp;


                    {volData !== null ? <>
                        {volPer === "week" && volData?.week?.[0]?.[0] && <>Sales: {volData.week[0][0].sales}, Vol {volData.week[0][0].vol}, Floor {volData.week[0][0].floorprice}</>}
                        {volPer === "month" && volData?.month?.[0]?.[0] && <>Sales: {volData.month[0][0].sales}, Vol {volData.month[0][0].vol}, Floor {volData.month[0][0].floorprice}</>}
                        {volPer === "all" && volData?.alltime?.[0]?.[0] && <>Sales: {volData.alltime[0][0].sales}, Vol {volData.alltime[0][0].vol}, Floor {volData.alltime[0][0].floorprice}</>}

                    </> : null}
                        </div>

                <p className={"text-light"} >{shit?.nft_desc} {shit?.text2}</p>
                <div style={{display: "flex", flexDirection: "row"}}>
                    <div style={{flex:1, alignSelf: "flex-end"}}>
                { !ti?.auctionData ?
                    <> { !ti?.unminted?
                        <p className="text-bold mb-10">Item not currently for sale</p> :
                        <p className="text-bold mb-10">This item has not been minted yet!</p>
                       }
                       </>: <>
                    { ti?.auctionData ? <p className="text-bold">
                        { ti?.auctionData?.finalizeOnReserveMet === true ? <>
                                Buy It Now : <span className="text-accent text-lg">{
                            ti?.auctionData ?
                                Web3.utils.fromWei(ti?.auctionData?.reserveAmount).toString()+" "+ti?.bcd?.chainInf?.tokName :
                                <p>Meh</p>}</span> &nbsp;{usdPrice}&nbsp; {sellerDesc} </> :
                        <div className={"w-100"}>Bid: <span className="text-accent text-lg">{
                            ti?.auctionData ?
                                Web3.utils.fromWei(ti?.auctionData?.bidAmount).toString()+" "+ti?.bcd?.chainInf?.tokName :
                                <p>Meh</p>}</span>&nbsp;{usdPrice}&nbsp;&nbsp;&nbsp;Reserve: <span className="text-accent text-lg">{
                            ti?.auctionData ?
                                Web3.utils.fromWei(ti?.auctionData?.reserveAmount).toString()+" "+ti?.bcd?.chainInf?.tokName :
                                <p>Meh</p>} </span></div> }
                </p> : <></> } </> }
                    </div>
                    <div style={{ marginLeft: "auto"}}>
                        <Vcl/>
                        <TwitterShareButton key={"twshare"}
                        title={"Check out this cool item from the "+ti?.dbCdata?.symbol+" collection!"}
                        url={"https://stealthisnft.xyz"+location.pathname}
                        hashtags={[ti?.dbCdata?.name, ...[ti?.dbCdata?.symbol?.split(" ")]]}><TwitterIcon size="24" round={true}/></TwitterShareButton>
                        <FacebookShareButton key={"fbshare"}
                            title={"Check out this cool item from the "+ti?.dbCdata?.symbol+" collection!"}
                            url={"https://stealthisnft.xyz"+location.pathname}
                            hashtags={[ti?.dbCdata?.name, ...[ti?.dbCdata?.symbol?.split(" ")]]}><FacebookIcon size="24" round={true}/></FacebookShareButton>
                        <TelegramShareButton key={"tgshare"}
                            title={"Check out this cool item from the "+ti?.dbCdata?.symbol+" collection!"}
                            url={"https://stealthisnft.xyz"+location.pathname}
                            hashtags={[ti?.dbCdata?.name, ...[ti?.dbCdata?.symbol?.split(" ")]]}><TelegramIcon size="24" round={true}/></TelegramShareButton>
                    </div>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <AddressToAccount address={ti?.owner} flags={null} title1={"Token Owner"} title2={"Owner"}/>
                    </div>
                    {/*right hand side*/}
                    <div className="col-md-6">
                        <AddressToAccount address={ti?.contractOwner} flags={null} title1={"Collection Owner"} title2={"Artist"}/>
                        <div className="p-2 text-light">Network: {net}</div>
                    </div>
                    {/*//underneath*/}
                        <div style={{display: "flex", flex: 1, justifyContent: "left", flexWrap: "wrap"}}>
                        {actionButtons.map((butObj, index) => <React.Fragment key={index}>{butObj}</React.Fragment>)}
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
export default SectionInfo